import LottieAnimation from '@CS/components/LottieAnimation';
import Spinner from '@CS/assets/loader.svg?react';
import { Loader as Assets } from '@CS/assets';
import CSS from './Loader.module.css';

export type LoaderProps = {
  image?: string | true;
  lottie?: JSON | true;
  opacity?: number;
  color?: string;
  size?: number;
};

export const Loader = ({
  color = 'white',
  opacity = 0.0,
  size = 50,
  lottie,
  image
}: LoaderProps) => (
  <aside
    className={CSS.loaderContainer}
    style={{ backgroundColor: `rgb(0 0 0 / ${opacity})` }}
  >
    {lottie ? (
      <div className={CSS.imageContainer} style={{ width: `${size}px` }}>
        <LottieAnimation
          animationData={
            (lottie === true && Assets.lottie) ||
            (lottie as unknown as Record<string, unknown>)
          }
        />
      </div>
    ) : image ? (
      <div className={CSS.imageContainer} style={{ width: `${size}px` }}>
        <img src={(image === true && Assets.gif) || (image as string)} />
      </div>
    ) : (
      <div
        style={{ height: `${size}px`, width: `${size}px`, color }}
        className={CSS.spinnerContainer}
      >
        <Spinner />
      </div>
    )}
  </aside>
);
